
import { request } from './';

const add = async (data) => {
    const result = await request('/locations/add', { data });
    return result.data;
};

const edit = async (location, data) => {
    const result = await request('/locations/edit', { location, data });
    return result.data;
};

const archive = async (location) => {
    const result = await request('/locations/archive', { location });
    return result.data;
};

const list = async () => {
    const result = await request('/locations/list', {});
    return result.data;
};

const earned = async () => {
    const result = await request('/locations/earned', {});
    return result.data;
};

const find = async (location, distance) => {
    const result = await request('/locations/find', { location, data: { distance } });
    return result.data;
};

export default {
    add,
    edit,
    archive,
    list,
    earned,
    find
};
